import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useSellMoneyStore } from '@/store/useSellMoneyStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency, cryptoToBig, cryptoToFiat } = currencyUtils

export const SellMoneyMaximumButton: React.FC = () => {
  const fromCurrency = useSellMoneyStore((state) => state.fromCurrency)
  const setIsFiatMode = useSellMoneyStore((state) => state.setIsFiatMode)
  const setCryptoAmount = useSellMoneyStore((state) => state.setCryptoAmount)
  const setFiatAmount = useSellMoneyStore((state) => state.setFiatAmount)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  if (!fromCurrency) {
    return null
  }

  const handlePress = () => {
    // Get the available balance - use amountWithoutNumberConversion for precision
    const availableAmount = fromCurrency.amountWithoutNumberConversion || String(fromCurrency.amount || '0')

    // Use cryptoToBig to format the amount (similar to withdraw)
    const bigAmount = cryptoToBig({
      amount: availableAmount,
    })

    // Calculate fiat equivalent
    const fiatAmount = cryptoToFiat({
      amountCrypto: Number(availableAmount),
      cryptoPricePerUnit: fromCurrency.pricePerUnit ?? 0,
    })

    // Set to crypto mode (like withdraw)
    setIsFiatMode(false)

    // Set the exact amounts
    setCryptoAmount({
      amount: bigAmount,
      code: fromCurrency.code ?? 'USDT',
    })

    setFiatAmount({
      amount: fiatAmount,
      code: displayCurrency?.isin || 'USD',
    })
  }

  // Format amount for display
  const formattedAmount = formatDynamicCurrency({
    amount: fromCurrency.amountWithoutNumberConversion || String(fromCurrency.amount ?? '0'),
    currencyCode: fromCurrency.code ?? 'USDT',
  })

  const availableAmount = `Maximum: ${formattedAmount}`

  return (
    <BaseView center>
      <div
        onClick={handlePress}
        style={{ alignSelf: 'center', cursor: 'pointer' }}
        className="transition-opacity duration-200 hover:opacity-80"
      >
        <BaseText
          fontSize={16}
          fontFamily="semibold"
          color="label.clickable"
          textAlign="center"
        >
          {availableAmount}
        </BaseText>
      </div>
    </BaseView>
  )
}
